<template>
  <div @click="handleClick" class="table-modal-wrapper transaction">
    <div ref="modal" class="table-modal">
      <div style="text-align: right" class="p-3">
        <i
          style="cursor: pointer"
          @click="closeModal"
          class="far fa-times-circle"
        ></i>
      </div>
      <p class="badge custom-badge" @click="copy">
        Transaction Reference: <b>{{ data.reference }}</b>
      </p>

      <div
        class="p-4 border-top"
        style="
          margin-bottom: 10px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        "
      >
        <h4 class="font-weight-bold">Payment Information</h4>
        <div class="content">
          <div class="information">
            <p>Amount</p>
            <span>{{ data.currency }} {{ toCurrency(data.amount, " ") }}</span>
          </div>
          <div class="information">
            <p>Narration</p>
            <span>{{ data.narration }} </span>
          </div>
          <div class="information">
            <p>Description</p>
            <span>{{ data.description }} </span>
          </div>
          <div class="information">
            <p>Transaction Date</p>
            <span>
              {{
                timeDateFormat(data.created_at).date +
                " " +
                timeDateFormat(data.created_at).time
              }}
            </span>
          </div>
        </div>
        <h4 class="font-weight-bold mt-2">Customer Information</h4>
        <div class="content">
          <div class="information">
            <p>Customer Name</p>
            <span>{{ data.customerName }}</span>
          </div>
          <div class="information">
            <p>Customer Email</p>
            <span>{{ data.customerEmail }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { notifications } from "../../../../../../public/assets/mixins/notifications";
import {
  titleCase,
  timeDateFormat,
  copyToClipboard,
  toCurrency,
} from "@/utils/helpers";
// import "./TransactionsTable.css";

export default {
  mixins: [notifications],
  name: "CashRegisterModal",
  props: {
    data: {
      type: Object,
    },
  },

  methods: {
    titleCase,
    timeDateFormat,
    toCurrency,
    handleClick(e) {
      if (!e.target.closest(".table-modal")) {
        return this.$emit("close-modal");
      }
    },
    closeModal(e) {
      this.$emit("close-modal");
    },
    copy() {
      const copied = copyToClipboard(this.data.reference);
      copied && this.showSuccessNotification("Transaction Reference Copied!");
    },
  },
};
</script>
